import Vue from 'vue';
import { config } from '@/config/bzbsconfig.js';

/**
 * * constructor
 * @param {string} mode cookie  - use cookie storage (default)
 *                      session - use browser session storage
 *                      local   - use browser local storage
 *
 * * method
 * @method setCache
 * @method getCache
 * @method removeCache
 */
export default function CacheHelper(mode) {
    this.cache = null;
    this.construct = function(mode) {
        switch (mode) {
            case 'session':
                this.cache = new SessionCache();
                break;
            case 'local':
                this.cache = new LocalCache();
                break;
            default:
                this.cache = new CookieCache();
        }
    };
    this.construct(mode);

    /**
     * @param {string} key
     * @param {object|array} data
     */
    this.setCache = function(key, data) {
        this.cache.removeCache(key);
        this.cache.setCache(key, JSON.stringify(data));
    };

    /**
     * @param {string} key
     */
    this.getCache = function(key) {
        var data = this.cache.getCache(key);
        var json = null;
        try {
            json = JSON.parse(data);
            return json
        } catch {
            return data;
        }
    };

    /**
     * @param {string} key
     */
    this.removeCache = function(key) {
        this.cache.removeCache(key);
    };
}


function CookieCache() {
    this.setCache = function(key, data) {
        var secureCookie = config.debug ? false : true;
        Vue.$cookies.set(key, data, null, null, null, secureCookie);
    };
    this.getCache = function(key) {
        return Vue.$cookies.get(key);
    };
    this.removeCache = function(key) {
        Vue.$cookies.remove(key);
    };
}

function SessionCache() {
    this.setCache = function(key, data) {
        window.sessionStorage.setItem(key, data);
    };
    this.getCache = function(key) {
        return window.sessionStorage.getItem(key);
    };
    this.removeCache = function(key) {
        return window.sessionStorage.removeItem(key);
    };
}

function LocalCache() {
    this.setCache = function(key, data) {
        window.localStorage.setItem(key, data);
    };
    this.getCache = function(key) {
        return window.localStorage.getItem(key);
    };
    this.removeCache = function(key) {
        window.localStorage.removeItem(key);
    };
}
